export enum CONTENT_SIDEBAR_MODE {
  EDIT = 'EDIT',
  VIEWER = 'VIEWER'
}